/** @format */
import React from "react";
import Select from "react-select";
import { useSelector } from "react-redux";

export const CustomSelectAsync = ({
  className,
  placeholder,
  field,
  form,
  isMulti = false,
  onChangeFunc,
  data,
  isLoading,
  endpoint,
}) => {
  const { layout } = useSelector((state) => ({
    layout: state.Layout,
  }));

  const onChange = (option) => {
    form.setFieldValue(
      field.name,
      isMulti ? option.map((item) => item.value) : option.value
    );
  };

  const handleBackgroundColorOption = (isFocused, isDisabled) => {
    if (layout?.layoutModeType === "dark") {
      return "#262a2f";
    } else {
      if (isDisabled) {
        return undefined;
      } else {
        if (!isFocused) {
          return "white";
        } else {
          return "#f3f6f9";
        }
      }
    }
  };

  const handleColorOption = (isFocused, isDisabled) => {
    if (layout?.layoutModeType === "dark") {
      if (isDisabled) {
        return undefined;
      } else {
        if (!isFocused) {
          return "#878a99";
        } else {
          return "white";
        }
      }
    } else {
      if (isDisabled) {
        return undefined;
      } else {
        if (!isFocused) {
          return "#878a99";
        } else {
          return "#black";
        }
      }
    }
  };

  const customStylesforSelect = {
    control: (provided, { isFocused, isDisabled }) => ({
      ...provided,
      backgroundColor: handleBackgroundColorOption(isFocused, isDisabled),
      color: layout?.layoutModeType === "dark" ? "white" : "black",
    }),
    menuList: (provided) => ({
      ...provided,
      backgroundColor: "#white",
      color: "black",
    }),
    option: (provided, { isFocused, isDisabled }) => ({
      ...provided,
      backgroundColor: handleBackgroundColorOption(isFocused, isDisabled),
      color: handleColorOption(isFocused, isDisabled),
      "&:hover": {
        backgroundColor: isDisabled
          ? undefined
          : !isFocused
          ? "white"
          : "#f3f6f9",
        color: isDisabled ? undefined : !isFocused ? "#f3f6f9" : "black",
      },
    }),
    input: (provided) => ({
      ...provided,
      color: layout?.layoutModeType === "dark" ? "#ced4da" : "black",
    }),
    placeholder: (provided) => ({
      ...provided,
      color: layout?.layoutModeType === "dark" ? "#ced4da" : "black",
    }),

    singleValue: (provided, state) => {
      const opacity = state.isDisabled ? 0.5 : 1;
      const transition = "opacity 300ms";
      return { ...provided, opacity, transition, color: "black" };
    },
  };

  const getValue = () => {
    if (data) {
      return isMulti
        ? data.length !== 0
          ? data.filter((option) => field.value.indexOf(option.value) >= 0)
          : []
        : data.find((option) => option.value === field.value);
    } else {
      return isMulti ? [] : "";
    }
  };
  return (
    <>
      {data === null || isLoading ? (
        <p className="m-0 p-0">Loading ...</p>
      ) : (
        <Select
          styles={customStylesforSelect}
          className={className}
          name={field.name}
          value={getValue()}
          onChange={onChangeFunc ? onChangeFunc : onChange}
          placeholder={placeholder}
          options={data}
          isMulti={isMulti}
          disabled={isLoading}
        />
      )}
    </>
  );
};

export default CustomSelectAsync;
